<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="订单成功" left-arrow fixed  @click-left="back" />
        <van-row>
          <van-col span="4"></van-col>
          <van-col span="16">
              <div class="jump-order-body">
                <div class="jump-order-body-whd">
                    <van-icon name="success" />
                    <p >订单已提交，请等待审核结果!</p>
                </div>
                 <div class="jump-order-body-foot">
                    <p>消耗积分：<span>{{integral}}</span></p>
                </div>
                <div class="jump-order-body-foot">
                    <p>订单编号：<span>{{orderId}}</span></p>
                    <p>
                       <a href="https://www.wjx.cn/vm/Q3zNsam.aspx" style="color: #3c6eeb;text-decoration: underline;font-size:19px;">第一季度满意度调查</a>
                    </p>
                    <van-button size="large" url="#/integral/home">继续逛逛</van-button>
                </div>
            </div>
          </van-col>
          <van-col span="4"></van-col>
        </van-row>
    </div>
</template>
<script>
import { NavBar,Button,Row,Col } from "vant";
export default {
  name: "ordersuccess",
  components: {
    [NavBar.name]: NavBar,
    [Button.name]:Button,
    [Row.name]:Row,
    [Col.name]:Col
  },
  data() {
    return {
      orderId:0,
      integral:0,
      orderPrice:0
    };
  },
  methods: {
    back() {
      // history.back();
      this.$router.push('/integral/home')
    }
  },
  mounted(){
    this.orderId = this.$route.query.orderId;
    this.integral=this.$route.query.integral;
  }
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;
body {
  background-color: #f7f7f7;
}
.jump-order {
  padding-top: 50px;

  &-body {
    padding-top: 100px;
    &-whd {
      text-align: center;
      i {
        color: #fff;
        border-color: #1989fa;
        background-color: #1989fa;
        border-radius: 100%;
        font-size: 56px;
      }
      p{
        padding: 20px 0;
      }
    }
    &-foot{
      p{
        padding-left: 15px;
        margin-bottom: 10px;
        span{
          color: red;
        }
      }
      button{
        background-color: @bule-thame;
        color: white;
        font-weight: 700;
        border-radius: 5px;
        margin: 25px 0 10px;
      }
    }
  }
}
</style>


